import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_5220_130167)">
            <path d="M31.6654 38.5V34.8333C31.6654 32.8884 30.8927 31.0232 29.5175 29.6479C28.1422 28.2726 26.277 27.5 24.332 27.5H9.66536C7.72044 27.5 5.85518 28.2726 4.47991 29.6479C3.10465 31.0232 2.33203 32.8884 2.33203 34.8333V38.5"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.0013 20.1667C21.0514 20.1667 24.3346 16.8834 24.3346 12.8333C24.3346 8.78325 21.0514 5.5 17.0013 5.5C12.9512 5.5 9.66797 8.78325 9.66797 12.8333C9.66797 16.8834 12.9512 20.1667 17.0013 20.1667Z"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M42.668 38.5V34.8333C42.6668 33.2085 42.126 31.6301 41.1305 30.3459C40.135 29.0617 38.7412 28.1445 37.168 27.7383"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M29.832 5.73834C31.4095 6.14223 32.8076 7.05963 33.806 8.34591C34.8045 9.63219 35.3464 11.2142 35.3464 12.8425C35.3464 14.4708 34.8045 16.0528 33.806 17.3391C32.8076 18.6254 31.4095 19.5428 29.832 19.9467"
                stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_5220_130167">
                <rect width="44" height="44" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export default Icon;